/**
 * Border radius scale — Brand core V13 (chap. 13) : 8 · 12 · 16 · 999.
 * « 15 devient 12 » : boutons et champs prennent `md`, les cartes `lg`, les chips `full`.
 * `xl` reste la grande surface (feuille modale) que le livre ne chiffre pas.
 *
 * Keys omit the `$` prefix — Unistyles CSS variables on web reject `$` in names.
 */
export const radius = {
    sm: 8,
    md: 12,
    lg: 16,
    xl: 24,
    full: 9999,
} as const

export type RadiusKey = keyof typeof radius
